export default __webpack_public_path__ + "static/media/c_img.a371fb20.svg";